import { MeterLocationState } from './types';

const state = (): MeterLocationState => {
  return {
    meterLocations: [],
  };
};

export default state;
